import React from "react";

import "./SimpleBarChart.scss";
import { truncDecimals } from "utilities/numberUtils";

interface SimpleBarProps {
  figure: number | string;
  desc: string;
  width: string | number;
}

const SimpleBar: React.FC<SimpleBarProps> = ({ figure, desc, width }) => {
  return (
    <div data-testid={`${figure},${desc}`} className="simple-bar">
      <div className="simple-bar-title">{figure}</div>
      <div className="simple-bar-display" style={{ width: width }}>
        <div className="simple-bar-desc">{desc}</div>
      </div>
    </div>
  );
};

export interface ChartData {
  figure: number;
  desc: string;
}

interface SimpleBarChartProps {
  data: Array<ChartData>;
  percentage?: boolean;
  single?: boolean;
}

export const SimpleBarChart: React.FC<SimpleBarChartProps> = ({
  data,
  percentage,
  single
}) => {
  const maxValue = single ? 1 : Math.max(...data.map(entry => entry.figure));
  return (
    <div className="simple-chart">
      {data.map((entry, index) => (
        <SimpleBar
          key={index}
          figure={
            percentage
              ? `${truncDecimals(entry.figure * 100)}%`
              : truncDecimals(entry.figure)
          }
          desc={entry.desc}
          width={`${(entry.figure / maxValue) * 100}%`}
        />
      ))}
    </div>
  );
};
